export default __webpack_public_path__ + "static/media/TALI_Claim_Form.92c0f2f4.pdf";